<template>
  <v-container fluid class="tree-view-container">
    <!-- Decorative curves -->
    <div class="top-left-curve"></div>
    <div class="bottom-right-curve"></div>

    <!-- Main content -->
    <div class="tree-content">
      <!-- Small header -->
      <div class="tree-header">INTRODUCING</div>

      <!-- Main title -->
      <div class="tree-title">GLXY TREE</div>

      <!-- Subtitle -->
      <div class="tree-subtitle">Track your legacies. Tell your story.</div>

      <!-- Description -->
      <div class="tree-description">
        Add characters, track relationships, trace lineages, and upload custom
        information. Watch your legacy grow, one branch at a time.
      </div>

      <!-- CTA Button -->
      <a
        href="https://tree.glxysims.com"
        target="_blank"
        class="tree-cta-button"
      >
        ENTER TREE
      </a>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "ModsView",
};
</script>

<style scoped>
.tree-view-container {
  position: relative;
  width: 65vw;
  max-width: 900px;
  min-height: 800px;
  background-color: #d6d6d6;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin: 120px auto;
  padding: 60px 40px;
  border-radius: 30px;
  box-shadow: rgba(0, 0, 0, 0.8) 0px 5px 35px;
}

.top-left-curve,
.bottom-right-curve {
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
}

.top-left-curve {
  top: 5%;
  left: 0;
  width: 15%;
  height: auto;
  aspect-ratio: 2 / 5;
  background-image: url("@/assets/icons/topleft.png");
}

.bottom-right-curve {
  bottom: 5%;
  right: 0;
  width: 15%;
  height: auto;
  aspect-ratio: 6 / 7;
  background-image: url("@/assets/icons/bottomright.png");
}

.tree-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 1;
  max-width: 700px;
}

.tree-header {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: clamp(12px, 2vw, 18px);
  letter-spacing: 0.4em;
  color: #7e7e7e;
  margin-bottom: 10px;
}

.tree-title {
  font-family: "Playfair Display", serif;
  font-size: clamp(48px, 10vw, 100px);
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 20px;
  line-height: 1.1;
}

.tree-subtitle {
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 3vw, 28px);
  font-style: italic;
  color: #8f7463;
  margin-bottom: 30px;
}

.tree-description {
  font-family: "Balthazar", serif;
  font-size: clamp(14px, 2vw, 18px);
  line-height: 1.7;
  color: #4c3e34;
  margin-bottom: 40px;
  max-width: 600px;
}

.tree-cta-button {
  display: inline-block;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: clamp(14px, 2vw, 16px);
  letter-spacing: 0.2em;
  color: #ffffff;
  background-color: #8f7463;
  padding: 16px 48px;
  border-radius: 50px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 4px 12px;
}

.tree-cta-button:hover {
  background-color: #726f5d;
  transform: translateY(-2px);
  box-shadow: rgba(0, 0, 0, 0.4) 0px 6px 16px;
}

@media screen and (max-width: 768px) {
  .tree-view-container {
    padding: 40px 30px;
    margin: 20px auto;
  }

  .tree-description {
    margin-bottom: 30px;
  }

  .tree-cta-button {
    padding: 14px 36px;
  }
}
</style>
